import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import { serializer } from './serializer';

bus.on(
  constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESH,
  ({ page, userId } = {}) => {
    const requestId = `listAllTransactions-${Date.now()}`;
    const limit = 100;
    const pageToUse = parseInt(page || 0);

    const userStore = getStore('user');
    let url = `${constants.ENDPOINTS.TRANSACTIONS.GET_LIST}`;
    url = url.replace('{userId}', userId || '');
    url = url.replace('{offset}', pageToUse * limit);
    url = url.replace('{limit}', limit);
    console.log('🚀 ~ url:', url);

    bus.emit(EVENTS.TRANSACTIONS.LIST_ALL.REFRESHING);
    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: requestId,
      url,
      method: 'GET',
      data: {}
    });

    const handler = (res) => {
      if (res.id === requestId) {
        bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
        const parsed = serializer.deserialize(res);
        if (parsed.success) {
          bus.emit(EVENTS.TRANSACTIONS.LIST_ALL.REFRESHED, parsed.data);
        } else {
          bus.emit(EVENTS.TRANSACTIONS.LIST_ALL.REFRESH_ERROR, parsed);
        }
      }
    };
    bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
  }
);

bus.on(constants.EVENTS.TRANSACTIONS.LATEST.REFRESH, () => {
  const requestId = `latestTransactions-${Date.now()}`;

  const userStore = getStore('user');
  let url = `${constants.ENDPOINTS.TRANSACTIONS.GET_LATEST}`;
  url = url.replace('{userId}', userStore.state.current.id);

  bus.emit(EVENTS.TRANSACTIONS.LATEST.REFRESHING);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url,
    method: 'GET',
    data: {}
  });

  const handler = (res) => {
    if (res.id === requestId) {
      bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
      const parsed = serializer.deserialize(res, true);
      if (parsed.success) {
        bus.emit(EVENTS.TRANSACTIONS.LATEST.REFRESHED, parsed.data);
      } else {
        bus.emit(EVENTS.TRANSACTIONS.LATEST.REFRESH_ERROR, parsed);
      }
    }
  };
  bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
});

bus.on(constants.EVENTS.TRANSACTIONS.DETAIL.SHOW, (data) => {
  const requestId = `transactionDetail-${Date.now()}`;
  bus.emit(EVENTS.TRANSACTIONS.DETAIL.REFRESHING);
  const url = `${constants.ENDPOINTS.TRANSACTIONS.GET_DETAIL}`.replace(
    /{id}/,
    data?.id
  );
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: url,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      // bus.off(constants.EVENTS.NETWORK.RESPONSE);
      const parsed = serializer.deserializeTransactoinDetail(res);
      if (parsed.success) {
        bus.emit(EVENTS.TRANSACTIONS.DETAIL.REFRESHED, parsed.data);
      } else {
        bus.emit(EVENTS.TRANSACTIONS.DETAIL.REFRESH_ERROR, parsed);
      }
    }
  });
});

bus.on(constants.EVENTS.TRANSACTIONS.MARK_AS_SUCCESS, ({ transactionId }) => {
  const requestId = `markAsSuccess-${Date.now()}`;
  bus.emit(constants.EVENTS.TRANSACTIONS.UPDATING);
  bus.emit(constants.EVENTS.LOADING.START);

  const url = `${constants.ENDPOINTS.TRANSACTIONS.MARK_SUCCESS}`.replace(
    /{id}/,
    transactionId
  );

  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url,
    method: 'POST',
    data: {}
  });

  const handler = (res) => {
    if (res.id === requestId) {
      bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
      bus.emit(constants.EVENTS.LOADING.FINISH);

      const parsed = serializer.deserializeTransactoinDetail(res);
      if (parsed.success) {
        bus.emit(constants.EVENTS.TRANSACTIONS.UPDATED, parsed.data);
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Succès',
          body: 'Transaction marquée comme réussie'
        });
        bus.emit(constants.EVENTS.TRANSACTIONS.DETAIL.SHOW, { id: transactionId });
      } else {
        bus.emit(constants.EVENTS.TRANSACTIONS.UPDATE_ERROR, parsed);
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Erreur',
          body: parsed.message || 'Impossible de marquer la transaction comme réussie'
        });
      }
    }
  };
  bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
});

bus.on(constants.EVENTS.TRANSACTIONS.MARK_AS_REFUNDED, ({ transactionId }) => {
  const requestId = `markAsRefunded-${Date.now()}`;
  bus.emit(constants.EVENTS.TRANSACTIONS.UPDATING);
  bus.emit(constants.EVENTS.LOADING.START);

  const url = `${constants.ENDPOINTS.TRANSACTIONS.MARK_REFUNDED}`.replace(
    /{id}/,
    transactionId
  );

  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url,
    method: 'POST',
    data: {}
  });

  const handler = (res) => {
    if (res.id === requestId) {
      bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
      bus.emit(constants.EVENTS.LOADING.FINISH);

      const parsed = serializer.deserializeTransactoinDetail(res);
      if (parsed.success) {
        bus.emit(constants.EVENTS.TRANSACTIONS.UPDATED, parsed.data);
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Succès',
          body: 'Transaction marquée comme remboursée'
        });
        bus.emit(constants.EVENTS.TRANSACTIONS.DETAIL.SHOW, { id: transactionId });
      } else {
        bus.emit(constants.EVENTS.TRANSACTIONS.UPDATE_ERROR, parsed);
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Erreur',
          body: parsed.message || 'Impossible de marquer la transaction comme remboursée'
        });
      }
    }
  };
  bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
});

bus.on(constants.EVENTS.TRANSACTIONS.RETRY_DESTINATION, ({ transactionId }) => {
  const requestId = `retryDestination-${Date.now()}`;
  bus.emit(constants.EVENTS.TRANSACTIONS.UPDATING);
  bus.emit(constants.EVENTS.LOADING.START);

  const url = `${constants.ENDPOINTS.TRANSACTIONS.RETRY_DESTINATION}`.replace(
    /{id}/,
    transactionId
  );

  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url,
    method: 'POST',
    data: {}
  });

  const handler = (res) => {
    if (res.id === requestId) {
      bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
      bus.emit(constants.EVENTS.LOADING.FINISH);

      const parsed = serializer.deserializeTransactoinDetail(res);
      if (parsed.success) {
        bus.emit(constants.EVENTS.TRANSACTIONS.UPDATED, parsed.data);
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Succès',
          body: 'Destination relancée avec succès'
        });
        bus.emit(constants.EVENTS.TRANSACTIONS.DETAIL.SHOW, { id: transactionId });
      } else {
        bus.emit(constants.EVENTS.TRANSACTIONS.UPDATE_ERROR, parsed);
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Erreur',
          body: parsed.message || 'Impossible de relancer la destination'
        });
      }
    }
  };
  bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
});
